/**
 * FormPreview UI translations
 *
 * These translations are separate from i18next because FormPreview has its own
 * language selection system (form content preview) that's independent from the
 * main app language (UI language).
 */

export const FORM_PREVIEW_TRANSLATIONS = {
  // Text input placeholder: "Add your answer here"
  // Used for: "Other" option input, Short text, Long text, Number inputs
  textInputPlaceholder: {
    'ar-AR': 'أضف إجابتك هنا',
    'bg-BG': 'Добавете вашия отговор тук',
    'cs-CS': 'Přidejte svou odpověď zde',
    'da-DK': 'Tilføj dit svar her',
    'de-DE': 'Fügen Sie hier Ihre Antwort hinzu',
    'el-GR': 'Προσθέστε την απάντησή σας εδώ',
    'en-GB': 'Add your answer here',
    'es-ES': 'Añade tu respuesta aquí',
    'fi-FI': 'Lisää vastauksesi tähän',
    'fr-FR': 'Ajoutez votre réponse ici',
    'he-IL': 'הוסף את התשובה שלך כאן',
    'hi-IN': 'अपना उत्तर यहां जोड़ें',
    'hu-HU': 'Adja hozzá a válaszát itt',
    'id-ID': 'Tambahkan jawaban Anda di sini',
    'it-IT': 'Aggiungi la tua risposta qui',
    'ja-JA': 'ここに答えを追加してください',
    'ko-KO': '여기에 답변을 추가하세요',
    'ms-MY': 'Tambah jawapan anda di sini',
    'nl-BE': 'Voeg hier uw antwoord toe',
    'nl-NL': 'Voeg hier uw antwoord toe',
    'no-NO': 'Legg til svaret ditt her',
    'pl-PL': 'Dodaj swoją odpowiedź tutaj',
    'pt-BR': 'Adicione sua resposta aqui',
    'pt-PT': 'Adicione a sua resposta aqui',
    'ro-RO': 'Adăugați răspunsul dvs. aici',
    'ru-RU': 'Добавьте свой ответ здесь',
    'sk-SK': 'Pridajte svoju odpoveď sem',
    'sl-SL': 'Dodajte svoj odgovor tukaj',
    'sv-SE': 'Lägg till ditt svar här',
    'th-TH': 'เพิ่มคำตอบของคุณที่นี่',
    'tr-TR': 'Cevabınızı buraya ekleyin',
    uk: 'Додайте свою відповідь тут',
    'ur-PK': 'اپنا جواب یہاں شامل کریں',
    vi: 'Thêm câu trả lời của bạn tại đây',
    'zh-CN': '在此添加您的答案',
  },
  // Dropdown placeholder: "Select an option"
  dropdownPlaceholder: {
    'ar-AR': 'حدد خيارًا',
    'bg-BG': 'Изберете опция',
    'cs-CS': 'Vyberte možnost',
    'da-DK': 'Vælg en mulighed',
    'de-DE': 'Wählen Sie eine Option',
    'el-GR': 'Επιλέξτε μια επιλογή',
    'en-GB': 'Select an option',
    'es-ES': 'Seleccione una opción',
    'fi-FI': 'Valitse vaihtoehto',
    'fr-FR': 'Sélectionnez une option',
    'he-IL': 'בחר אפשרות',
    'hi-IN': 'एक विकल्प चुनें',
    'hu-HU': 'Válasszon egy lehetőséget',
    'id-ID': 'Pilih opsi',
    'it-IT': "Seleziona un'opzione",
    'ja-JA': 'オプションを選択',
    'ko-KO': '옵션 선택',
    'ms-MY': 'Pilih pilihan',
    'nl-BE': 'Selecteer een optie',
    'nl-NL': 'Selecteer een optie',
    'no-NO': 'Velg et alternativ',
    'pl-PL': 'Wybierz opcję',
    'pt-BR': 'Selecione uma opção',
    'pt-PT': 'Selecione uma opção',
    'ro-RO': 'Selectați o opțiune',
    'ru-RU': 'Выберите вариант',
    'sk-SK': 'Vyberte možnosť',
    'sl-SL': 'Izberite možnost',
    'sv-SE': 'Välj ett alternativ',
    'th-TH': 'เลือกตัวเลือก',
    'tr-TR': 'Bir seçenek seçin',
    uk: 'Виберіть варіант',
    'ur-PK': 'ایک آپشن منتخب کریں',
    vi: 'Chọn một tùy chọn',
    'zh-CN': '选择一个选项',
  },
  // Database field label: "Search"
  databaseFieldLabel: {
    'ar-AR': 'بحث',
    'bg-BG': 'Търсене',
    'cs-CS': 'Hledat',
    'da-DK': 'Søg',
    'de-DE': 'Suchen',
    'el-GR': 'Αναζήτηση',
    'en-GB': 'Search',
    'es-ES': 'Buscar',
    'fi-FI': 'Haku',
    'fr-FR': 'Rechercher',
    'he-IL': 'חיפוש',
    'hi-IN': 'खोजें',
    'hu-HU': 'Keresés',
    'id-ID': 'Cari',
    'it-IT': 'Cerca',
    'ja-JA': '検索',
    'ko-KO': '검색',
    'ms-MY': 'Cari',
    'nl-BE': 'Zoeken',
    'nl-NL': 'Zoeken',
    'no-NO': 'Søk',
    'pl-PL': 'Szukaj',
    'pt-BR': 'Pesquisar',
    'pt-PT': 'Pesquisar',
    'ro-RO': 'Căutare',
    'ru-RU': 'Поиск',
    'sk-SK': 'Hľadať',
    'sl-SL': 'Iskanje',
    'sv-SE': 'Sök',
    'th-TH': 'ค้นหา',
    'tr-TR': 'Ara',
    uk: 'Пошук',
    'ur-PK': 'تلاش کریں',
    vi: 'Tìm kiếm',
    'zh-CN': '搜索',
  },
  // Database field placeholder: "Select someone from employee directory"
  databaseFieldPlaceholder: {
    'ar-AR': 'حدد شخصًا من دليل الموظفين',
    'bg-BG': 'Изберете някой от директорията на служителите',
    'cs-CS': 'Vyberte někoho z adresáře zaměstnanců',
    'da-DK': 'Vælg nogen fra medarbejderoversigten',
    'de-DE': 'Wählen Sie jemanden aus dem Mitarbeiterverzeichnis',
    'el-GR': 'Επιλέξτε κάποιον από τον κατάλογο υπαλλήλων',
    'en-GB': 'Select someone from employee directory',
    'es-ES': 'Seleccione a alguien del directorio de empleados',
    'fi-FI': 'Valitse joku työntekijähakemistosta',
    'fr-FR': "Sélectionnez quelqu'un dans le répertoire des employés",
    'he-IL': 'בחר מישהו ממדריך העובדים',
    'hi-IN': 'कर्मचारी निर्देशिका से किसी को चुनें',
    'hu-HU': 'Válasszon ki valakit az alkalmazotti könyvtárból',
    'id-ID': 'Pilih seseorang dari direktori karyawan',
    'it-IT': 'Seleziona qualcuno dalla rubrica dei dipendenti',
    'ja-JA': '従業員ディレクトリから選択してください',
    'ko-KO': '직원 디렉토리에서 선택하세요',
    'ms-MY': 'Pilih seseorang dari direktori pekerja',
    'nl-BE': 'Selecteer iemand uit de werknemersgids',
    'nl-NL': 'Selecteer iemand uit de werknemersgids',
    'no-NO': 'Velg noen fra ansattoversikten',
    'pl-PL': 'Wybierz kogoś z katalogu pracowników',
    'pt-BR': 'Selecione alguém do diretório de funcionários',
    'pt-PT': 'Selecione alguém do diretório de funcionários',
    'ro-RO': 'Selectați pe cineva din directorul angajaților',
    'ru-RU': 'Выберите кого-нибудь из справочника сотрудников',
    'sk-SK': 'Vyberte niekoho zo zoznamu zamestnancov',
    'sl-SL': 'Izberite nekoga iz imenika zaposlenih',
    'sv-SE': 'Välj någon från medarbetarkatalogen',
    'th-TH': 'เลือกบุคคลจากไดเรกทอรีพนักงาน',
    'tr-TR': 'Çalışan dizininden birini seçin',
    uk: 'Виберіть когось із довідника співробітників',
    'ur-PK': 'ملازمین کی فہرست سے کسی کو منتخب کریں',
    vi: 'Chọn ai đó từ thư mục nhân viên',
    'zh-CN': '从员工目录中选择',
  },
} as const;

/**
 * Get a translated string for FormPreview UI
 *
 * @param key - Translation key from FORM_PREVIEW_TRANSLATIONS
 * @param languageCode - Language code (e.g., 'fr-FR', 'cs-CS')
 * @returns Translated string, falls back to English if not found
 */
export function getFormPreviewTranslation(
  key: keyof typeof FORM_PREVIEW_TRANSLATIONS,
  languageCode: string | null,
): string {
  if (!languageCode) {
    return FORM_PREVIEW_TRANSLATIONS[key]['en-GB'];
  }

  const translations = FORM_PREVIEW_TRANSLATIONS[key];
  return (
    translations[languageCode as keyof typeof translations] ||
    translations['en-GB']
  );
}
